// extracted by mini-css-extract-plugin
module.exports = {"root":"cards-grid_root__oB3Ar"};